import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { User } from '../../models/user';
import { ImmobilierService } from '../../services/immobilier.service';

@Component({
  selector: 'app-add-edit-agent-dialog',
  templateUrl: './add-edit-agent-dialog.component.html',
  styleUrls: ['./add-edit-agent-dialog.component.css']
})
export class AddEditAgentDialogComponent implements OnInit {

  agent: User;
  isNew: boolean;

  profiles = [
    { value: 'ADMINISTRATEUR', label: 'Administrateur' },
    { value: 'Agent', label: 'Agent Immobilier' },
    { value: 'Gestionnaire', label: 'Gestionnaire' }
  ];

  constructor(
    public dialogRef: MatDialogRef<AddEditAgentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private immobilierService: ImmobilierService,
    private snackBar: MatSnackBar
  ) {
    this.isNew = data.isNew;
    if (this.isNew) {
      this.agent = {
        firstName: '',
        lastName: '',
        login: '',
        password: '',
        profile: 'agent',
        status: 'actif'
      };
    } else {
      this.agent = { ...data.agent };
      // Clear password field for edit, only send if user types a new one
      this.agent.password = '';
    }
  }

  ngOnInit(): void {
  }

  isFormValid(): boolean {
    if (!this.agent.firstName || !this.agent.lastName || !this.agent.login || !this.agent.profile) {
      return false;
    }
    // Password is required only for new agents
    if (this.isNew && !this.agent.password) {
      return false;
    }
    return true;
  }

  save(): void {
    if (!this.isFormValid()) {
      this.snackBar.open('Veuillez remplir tous les champs obligatoires.', 'Fermer', { duration: 3000 });
      return;
    }

    if (this.isNew) {
      this.immobilierService.createUser(this.agent).subscribe({
        next: (res) => {
          this.snackBar.open('Agent créé avec succès', 'Fermer', { duration: 3000 });
          this.dialogRef.close(res);
        },
        error: (err) => {
          if (err.status === 400 && err.error && err.error.message) {
            this.snackBar.open(err.error.message, 'Fermer', { duration: 5000 });
          } else {
            this.snackBar.open('Erreur lors de la création', 'Fermer', { duration: 3000 });
          }
        }
      });
    } else {
      this.immobilierService.updateUser(this.agent.id!, this.agent).subscribe({
        next: (res) => {
          this.snackBar.open('Agent modifié avec succès', 'Fermer', { duration: 3000 });
          this.dialogRef.close(res);
        },
        error: (err) => {
          if (err.status === 400 && err.error && err.error.message) {
            this.snackBar.open(err.error.message, 'Fermer', { duration: 5000 });
          } else {
            this.snackBar.open('Erreur lors de la modification', 'Fermer', { duration: 3000 });
          }
        }
      });
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

}
